module.exports = __webpack_public_path__ + "media/images/background/working-6dd4a12942069687247721b1df61b17d.svg";